export default [
    {
        path: '/is-listesi',
        name: 'is-listesi',
        meta: { resource: 'admin|tech|personel' },
        component: () => import('../views/tech/list'),
    },
    {
        path: '/kurulum',
        name: 'kurulum',
        meta: { resource: 'admin|tech|personel' },
        component: () => import('../views/tech/list'),
    },
    
    {
        path: '/sokum-listesi',
        name: 'sokum-listesi',
        meta: { resource: 'admin|personel' },
        component: () => import('../views/customer/sokum'),
    },
    {
        path: '/ariza-listesi',
        name: 'ariza-listesi',
        meta: { resource: 'admin|personel' },
        component: () => import('../views/customer/ariza'),
    },
    {
        path: '/tasima-listesi',
        name: 'tasima-listesi',
        meta: { resource: 'admin|personel' },
        component: () => import('../views/customer/tasima'),
    },
    {
        path: '/teknik-servis-personel-listesi',
        name: 'teknik-servis-personel-listesi',
        meta: { resource: 'admin' },
        component: () => import('../views/tech/personel'),
    }
] 